var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clientCommon"},[_c('com-form',{ref:"clientCommon",attrs:{"label-width":"120px","label-position":"right","col":3,"configs":_vm.filterFormConfig,"showType":"info"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }